import Text from "shared/components/data-display/text/Text";
import { COLOR_VALUES } from "shared/config/colors";
import styled, { css } from "styled-components";

export const StyledTd = styled.td`
    padding: ${({ $compact }) =>
        $compact ? "2px 12px 1px 12px" : "6px 12px 5px 12px"};
    border-bottom: 1px solid ${COLOR_VALUES.Gray_6};
    height: ${({ $compact }) => ($compact ? "40px" : "52px")};
    text-align: start;
    vertical-align: middle;
    color: ${(props) => (props.textColor ? props.textColor : COLOR_VALUES.Gray_1)} ;
    padding: ${(props) => props.padding};
    border-bottom-color: ${(props) => props.borderColor};

    ${({ $shownByRowHover }) =>
        $shownByRowHover &&
        css`
            > * {
                opacity: 0;
            }
        `}

    tr:hover &, tr:focus-within & {
        color: ${COLOR_VALUES.Black};
        border-bottom-color: ${COLOR_VALUES.Gray_4};

        ${({ $shownByRowHover }) =>
        $shownByRowHover &&
        css`
                > * {
                    opacity: inherit;
                }
            `}
    }
`;

export const StyledText = styled(Text)`
    ${(props) =>
        !props.ellipsisAtLine &&
        css`
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        `}
`;
